import { createContext } from "react";

const PageItemMasterContext = createContext({});

export default PageItemMasterContext;
